import { ChangeDetectorRef, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ActivityServiceProxy, AllDashboardServiceProxy, ApplicationAndSpendTimeDto, CalculationTimeAndAttendanceDto, InputeTypeWiseCategoryAndApplicationDto, Proddata, ProductivityTypes, TimeAndAttendanceServiceProxy, UserWiseProductiveUnproductiveAndNuetralTimeDto } from '../../../../../shared/service-proxies/service-proxies';
import { DxPieChartComponent, DxPieChartModule } from "devextreme-angular";
import { ActivityService } from '../../../activities/services/activity.service';
import { Subscription } from 'rxjs';
import { DateTime } from 'luxon';
import { Workbook } from 'exceljs';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { DatePipe } from '@angular/common';
import jsPDF from 'jspdf';
import * as fs from 'file-saver';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { rotateOutUpRightOnLeaveAnimation } from 'angular-animations';
import { TimesheetUtilityService } from '@app/main/time-sheet/services/timesheet-utility.service';
import { AbpSessionService } from 'abp-ng2-module';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { AppComponentBase } from '@shared/common/app-component-base';


@Component({
    selector: 'app-dashboard-productivity-info-section',
    templateUrl: './dashboard-productivity-info-section.component.html',
    styleUrls: ['./dashboard-productivity-info-section.component.css']
})
export class DashboardProductivityInfoSectionComponent extends AppComponentBase implements OnInit {
    @ViewChild(DxPieChartComponent, { static: false }) pieChart: DxPieChartComponent;
    @ViewChild("timeAndAttendanceTabs", { static: false }) timeAndAttendanceTabs: TabsetComponent;
    //allPendingDataForExport: import('shared/service-proxies/service-proxies').PendingApplicationInfo[];
    //allApprovedDataForExport: import('shared/service-proxies/service-proxies').PendingApplicationInfo[];
    allPendingDataForExport: import('../../../../../shared/service-proxies/service-proxies').PendingApplicationInfo[];
    allApprovedDataForExport: import('../../../../../shared/service-proxies/service-proxies').PendingApplicationInfo[];


    areas: { appName: string, area: number }[] = [];
    pies: any;
    prouctive: any;
    applications: ApplicationAndSpendTimeDto[];
    userId = abp.session.userId;
    tenantId = abp.session.tenantId;
    firstPieChart: UserWiseProductiveUnproductiveAndNuetralTimeDto[];
    leftPieChartPercentageArray: number[];
    subscription: Subscription;
    userStats: CalculationTimeAndAttendanceDto;

    showEmptyScreenUI: boolean = false;
    datePipe: any;
    resolveOverlappingTypes = ['shift', 'hide', 'none'];
    dateTime = new Date();
    msg: string;
    //  pieColorPalette = [  /*blue*/'#6fcefb','#f37b87', /*grey*/'#e4e4e4'];  
    pieColorPalette = [];
    constructor(private _abpSessionService: AbpSessionService,
        private _monitorService: MonitoringService, private cdRef: ChangeDetectorRef,
        private _activityService: ActivityService,
        private _timeAndAttendanceServiceProxy: TimeAndAttendanceServiceProxy,
        private _activitesServiceProxy: ActivityServiceProxy,
        public _tus: TimesheetUtilityService,
        private _route: Router,
        injector: Injector,
        private _AllDashboardServiceProxy: AllDashboardServiceProxy) { super(injector); }

    ngOnInit(): void {        
        this.msg = "userId = " + this._abpSessionService.userId + "tenantId =" + this._abpSessionService.tenantId;
        this._monitorService.logPageView("UI-dashboardProductivityInfoSection");
        this.getTypeBaseApplicationSpendTime();
        this.getAllDataForExport();
        this.getAllApplicationForUser();
        this.pieChart?.customizePoint(function (pointInfo) {
            //console.log(pointInfo)
            if (pointInfo.argument === "Productive") {
                return {
                    color: "#6fcefb"
                }
            }
            if (pointInfo.argument === "Unproductive") {
                return {
                    color: "#f37b87"
                }
            }
            if (pointInfo.argument === "Neutral") {
                return {
                    color: "#e4e4e4"
                }
            }
        })

    }

    getTypeBaseApplicationSpendTime() {     
        var date = new Date();
        this._monitorService.logTrace("UI-getTypeBaseApplicationSpendTime", { "getTypeBaseApplicationSpendTime ": "getUserWiseProductiveUnProductiveAndNuetralData: " + this + this.dateTime })
        this._timeAndAttendanceServiceProxy.getUserWiseProductiveUnProductiveAndNuetralData(this.userId, this.tenantId, DateTime.fromJSDate(this._activityService.setZeroTimeForLocalDate(date)),date.getTimezoneOffset()).subscribe((r) => {
            //("App tracked resposes", r)
            this.firstPieChart = r;
            sessionStorage.setItem("applicationWiseSpentTime", JSON.stringify(r));
            let res = r;
            localStorage.setItem('appspenttime', JSON.stringify(res));
            let reducedTotalArr = r.map((r) => {
                return [
                    this.timeStampToSeconds(r.productiveTime),
                    this.timeStampToSeconds(r.unProductiveTime),
                    this.timeStampToSeconds(r.nuetralTime),
                ];
            });
            let totalArr = [0, 0, 0];
            var tot = 0;
            reducedTotalArr.forEach((r) => {
                totalArr[0] += r[0];
                totalArr[1] += r[1];
                totalArr[2] += r[2];
                tot += r[0] + r[1] + r[2];
            });

            this.leftPieChartPercentageArray = [];
            totalArr.map((r) => (r) / totalArr.reduce((a, v) => (a += v), 0));
            var a = (totalArr[0] / tot);
            this.leftPieChartPercentageArray.push(a);
            a = (totalArr[1] / tot);
            this.leftPieChartPercentageArray.push(a);
            a = (totalArr[2] / tot);
            this.leftPieChartPercentageArray.push(a);
            // console.log(this.leftPieChartPercentageArray, "left");
            // console.log(r, "result");
            if (totalArr[0] == 0 && totalArr[1] == 0 && totalArr[2] == 0) {
                this.showEmptyScreenUI = true;
                return;
            } else {
                this.showEmptyScreenUI = false;
            }
            this.leftPieChartPercentageArray = totalArr.map((r) => (r * 100.0) / totalArr.reduce((a, v) => (a += v), 0) / 100);
            let val = [
                new Proddata({
                    id: 0,
                    key: "productive",
                    val: this.leftPieChartPercentageArray[0] * 100,
                    val2: 0
                })
                ,
                new Proddata({
                    id: 1,
                    key: "unproductive",
                    val: this.leftPieChartPercentageArray[1] * 100,
                    val2: 0
                })
                ,
                new Proddata({
                    id: 2,
                    key: "Neutral",
                    val: this.leftPieChartPercentageArray[2] * 100,
                    val2: 0
                })
            ]

            if (this.leftPieChartPercentageArray[0] != 0 || this.leftPieChartPercentageArray[1] != 0 || this.leftPieChartPercentageArray[2] != 0) {

                this._timeAndAttendanceServiceProxy.calculateProperPercentage(val).subscribe(res => {

                    //console.log(res,"sdxsfdfsfsdfsdfsfs");
                    if (this.leftPieChartPercentageArray[0] !== 0) {

                        this.areas.push({ appName: this.l("Productive"), area: res[0].val / 100 });
                        this.pieColorPalette.push('#6fcefb');
                    }
                    if (this.leftPieChartPercentageArray[1] !== 0) {
                        this.areas.push({ appName: this.l("Unproductive"), area: res[1].val / 100 });
                        this.pieColorPalette.push('#f37b87');
                    }
                    if (this.leftPieChartPercentageArray[2] !== 0) {
                        this.areas.push({ appName: this.l("Neutral"), area: res[2].val / 100 });
                        this.pieColorPalette.push('#e4e4e4');
                    }


                });
            }
            else {
                if (this.leftPieChartPercentageArray[0] !== 0) {

                    this.areas.push({ appName: this.l("Productive"), area: this.leftPieChartPercentageArray[0] });
                    this.pieColorPalette.push('#6fcefb');
                }
                if (this.leftPieChartPercentageArray[1] !== 0) {
                    this.areas.push({ appName: this.l("Unproductive"), area: this.leftPieChartPercentageArray[1] });
                    this.pieColorPalette.push('#f37b87');
                }
                if (this.leftPieChartPercentageArray[2] !== 0) {
                    this.areas.push({ appName: this.l("Neutral"), area: this.leftPieChartPercentageArray[2] });
                    this.pieColorPalette.push('#e4e4e4');
                }
            }

        });

    }


    timeStampToSeconds(seconds: string) {
        if (!seconds) return 0;
        let arr = seconds.split(":").map((r) => parseInt(r));
        return arr[0] * 3600 + arr[1] * 60 + arr[2];
    }
    getAllApplicationForUser() {
        try {
            let date = new Date();
            let input = new InputeTypeWiseCategoryAndApplicationDto();
            input.tenantId = this.tenantId; input.userId = this.userId; input.productivityTypes = ProductivityTypes.Neutral;
                input.isAllTypes = true; input.calenderDate = DateTime.fromJSDate(this._activityService.setZeroTimeForLocalDate(date));
            this._monitorService.logTrace("UI-getAllApplicationForUser", { "getAllApplicationForUser ": "getTypeWiseCategotyAndApplication: " + this.msg + this.dateTime })
            this._timeAndAttendanceServiceProxy
                .combineApplicationDetails(input)
                .subscribe((r) => {
                    const totalAppCount = r.productiveUnProductiveNuetralDetail.reduce((a, v) => (a += v.applicationCount), 0);
                    let temp: Proddata[] = [];
                    let id1 = 0;
                    let flag = false;
                    r.productiveUnProductiveNuetralDetail.forEach(x => {
                        var t = new Proddata({
                            id: id1,
                            key: x.categoryName,
                            val: (x.applicationCount / totalAppCount) * 100,
                            val2: 0
                        });
                        id1++;
                        if (t.val > 0) {
                            flag = true;
                        }
                        temp.push(t);
                    });

                    if (flag) {
                        this._timeAndAttendanceServiceProxy.calculateProperPercentage(temp).subscribe(res => {



                            this.prouctive = res.map(x => {
                                return {
                                    appName: x.key,
                                    area: (x.val) / 100
                                };
                            });


                        });
                    }
                    else {
                        this.prouctive = r.productiveUnProductiveNuetralDetail.map((x) => {
                            return {
                                appName: x.categoryName,
                                area: (x.applicationCount / totalAppCount).toFixed(2),
                            };
                        });
                    }
                    // this._timeAndAttendanceServiceProxy
                    //     .getTypeBaseApplicationSpendTime(this.tenantId, this.userId, ProductivityTypes.Neutral, true, DateTime.fromJSDate(this._activityService.setZeroTimeForLocalDate(date)))
                    //     .subscribe((r) => {
                            this.applications = r.applicationTimeDetail;
                        // });
                });
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }

    }

    pointClickHandler(e) {
        // this.loadingCategoryData = true;
        let date = new Date();
        this._timeAndAttendanceServiceProxy
            .getTypeWiseCategotyAndApplication(this.tenantId, this.userId, ProductivityTypes[e.target.argument as string], false, DateTime.fromJSDate(this._activityService.setZeroTimeForLocalDate(date)),date.getTimezoneOffset())
            .subscribe((r) => {
                const totalAppCount = r.reduce((a, v) => (a += v.applicationCount), 0);
                this.prouctive = r.map((x) => {
                    return {
                        appName: x.categoryName,
                        area: (x.applicationCount / totalAppCount).toFixed(2),
                    };
                });
                // console.log('Pie2', this.prouctive);                
                this._timeAndAttendanceServiceProxy
                    .getTypeBaseApplicationSpendTime(this.tenantId, this.userId, ProductivityTypes[e.target.argument as string], false, DateTime.fromJSDate(this._activityService.setZeroTimeForLocalDate(date)),date.getTimezoneOffset())
                    .subscribe((r) => {
                        this.applications = r;
                        //this.loadingCategoryData = false;
                    });
            });
    }

    onPointHoverChanged(e) {
        const point = e.target;
        //let categoryName= point.data.appName;
        //point.value = categoryName;
        if (!point.isHovered()) {
            point.hideTooltip();
        }
        else {
            point.showTooltip();
        }
    }
    customizeTooltip(arg) {
        //  console.log("arg", arg);
        return { text: `${arg.argumentText}` };
    }
    exportToPdf(e) {
        try {
            this._monitorService.logTrace("UI-exportToPdf", { "exportToPdf ": "PDF export: " + this + this.msg + this.dateTime })
            const title = 'Approved Offline Times';
            let exportColumns = [
                { title: "User Name", dataKey: "fullName" },
                { title: "Project", dataKey: "projectName" },
                { title: "Submitted On", dataKey: "submittedOn" },
                { title: "Time Registered", dataKey: "leaveFromDate" },
                { title: "Type", dataKey: "leaveToDate" },
                { title: "Description", dataKey: "description" },
            ];
            const head = [['User Name', 'Project', 'Submitted On', 'Time Registered', 'Type', 'Description']];
            let ExcelDataArray = [];

            let curData = this.allPendingDataForExport;
            curData.forEach((x) => {

                let dateFormat = 'MMM d, y';
                let timeRegisterd = this.datePipe.transform(this.getLocalJsDate(x.startIdealTime), 'h:mm a') + " - " + this.datePipe.transform(this.getLocalJsDate(x.endIdealTime), 'h:mm a');
                let data = [x.fullName, x.projectName, this.datePipe.transform(this.getLocalJsDate(x.submittedOn), 'MMM d, y'),
                    timeRegisterd, this.getProductivityType(x.productivityType), x.description];
                ExcelDataArray.push(data);
            })
            const doc = new jsPDF("p", "pt");
            doc.text("Time Off Approvals", 40, 30);

            doc.setFontSize(7);
            doc.setTextColor(100);
            (doc as any).autoTable({
                head: head,
                body: ExcelDataArray,
                theme: 'grid',
                tableLineColor: [189, 195, 199],
                tableLineWidth: 0.75,
                startY: 40,
                margin: {
                    top: 60
                },
                styles: {
                    fontSize: 9
                },
                columnStyles: {
                    0: {},
                    1: {},
                    2: {},
                    3: {},
                    4: {},
                    5: {},
                    6: {},
                    7: {},
                }
            });

            doc.save(`${title}.pdf`);
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }

    }
    exportToExcel(e) {
        try {
            this._monitorService.logTrace("UI-exportToPdf", { "exportToPdf ": "PDF export: " + this + this.msg + this.dateTime })

            const title = 'Approved Offline Times';
            const head = ['User Name', 'Project', 'Submitted On', 'Time Registered', 'Type', 'Description'];
            let ExcelDataArray = [];
            let curData = this.allPendingDataForExport;
            let colWidth = head.map(s => s.length);
            curData.forEach((x) => {

                let dateFormat = 'MMM d, y';
                let timeRegisterd = this.datePipe.transform(this.getLocalJsDate(x.startIdealTime), 'h:mm a') + " - " + this.datePipe.transform(this.getLocalJsDate(x.endIdealTime), 'h:mm a');
                let data = [x.fullName, x.projectName, this.datePipe.transform(this.getLocalJsDate(x.submittedOn), 'MMM d, y'),
                    timeRegisterd, this.getProductivityType(x.productivityType), x.description];
                colWidth = data.map((val, idx) => Math.max(val ? val?.length : 0, colWidth[idx]))
                ExcelDataArray.push(data);
            })
            let workbook = new Workbook();
            let worksheet = workbook.addWorksheet('Offline Time');
            worksheet.addRow([]);
            worksheet.addRow(head);
            ExcelDataArray.forEach(d => {
                worksheet.addRow(d);
            }
            );
            colWidth.forEach((w, idx) => worksheet.columns[idx].width = w);
            workbook.xlsx.writeBuffer().then((data) => {
                let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                fs.saveAs(blob, title + '.xlsx');
            });
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }


    // get local js date from a UTC datetime object
    getLocalJsDate(date: DateTime): Date {
        let jsDate = new Date(
            `${date.year}-${date.month < 10 ? '0' + date.month : date.month}-${date.day < 10 ? '0' + date.day : date.day
            }T${date.hour < 10 ? '0' + date.hour : date.hour}:${date.minute < 10 ? '0' + date.minute : date.minute}:00`
        );
        return new Date(jsDate.getTime() - jsDate.getTimezoneOffset() * 60 * 1000);
    }

    getProductivityType(typeId: number) {
        return ["Productive", "Unproductive", "Neutral"][typeId - 1];
    }

    async getAllDataForExport() {
        //if (this.isManagerView) {
        //    this._timeAndAttendanceServiceProxy.getManualTimePendingList(this.userId, false).subscribe(r => {
        //        this.allPendingDataForExport = r?.pendingApplicationInfos;
        //        //this.pendingTabCount = r?.pendingApplicationInfos.length;
        //    })
        //} else {
        //    this._timeAndAttendanceServiceProxy.getManualTeamTimePendingList(abp.session.userId, false).subscribe(r => {
        //        this.allPendingDataForExport = r?.pendingApplicationInfos;
        //        //this.pendingTabCount = r?.pendingApplicationInfos.length;
        //    })
        //}
        //if (this.isManagerView) {
        //    this._timeAndAttendanceServiceProxy.getApproveManualTime(this.userId).subscribe(r => {
        //        this.allApprovedDataForExport = r?.pendingApplicationInfos;
        //        //this.approvedTabCout = r?.pendingApplicationInfos.length;
        //    })
        //} else {
        //    this._timeAndAttendanceServiceProxy.getTeamApproveManualTime(abp.session.userId).subscribe(r => {
        //        this.allApprovedDataForExport = r?.pendingApplicationInfos;
        //        //this.approvedTabCout = r?.pendingApplicationInfos.length;
        //    })
        //}
        let pendingData = [];
        /*  await this._timeAndAttendanceServiceProxy.getManualTimePendingList(this.userId, false,1000,0,null).subscribe(r => {
              pendingData = r?.items[0].pendingApplicationInfos;
              //this.pendingTabCount = r?.pendingApplicationInfos.length;
          })*/

        let approvedData = [];

        /*   await this._timeAndAttendanceServiceProxy.getApproveManualTime(this.userId, 1000, 0, null).subscribe(r => {
   
               approvedData = r?.items[0].pendingApplicationInfos;
               //this.approvedTabCout = r?.pendingApplicationInfos.length;
             
           })*/

        this.allPendingDataForExport = [...pendingData, ...approvedData];
    }


    viewAll() {
        localStorage.setItem('isViewAllFromDashboard','true');
        this._route.navigate(['app/main/activities/time-and-attendance']);
    }



    legendClickHandler(e) {
        const arg = e.target;
        const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];

        // this.toggleVisibility(item);
    }

    // toggleVisibility(item) {
    //     if (item.isVisible()) {
    //         item.hide();
    //     }
    // }
    timerToMinsHrsSecs(timer: string): string {
        if (!timer) timer = '00:00:00';
        let hrsStr = (timer.split(':')[0]);
        let minsStr = timer.split(':')[1];
        let secsStr = timer.split(':')[2];
        let hrs = Math.floor(parseFloat(hrsStr));
        let mins = Math.floor(parseFloat(minsStr));
        let secs = Math.floor(parseFloat(secsStr));

        if (mins == 0 && hrs == 0) {
            return `${secs}s`;
        } else if (hrs == 0) {
            return `${mins}m`;
        }
        return `${hrs}h ${mins}m`;
    }
    ShowDetails = false;
    LoadingStarted = false;
    HistoryForApp = "";
    HistoryDetails = [];
    GetData(appName: string) {
        this.HistoryForApp = appName;
        this.ShowDetails = false;
        document.getElementsByClassName('popTemplateClass')[0].className += ' display-none';
        this.LoadingStarted = true;
        this._activitesServiceProxy.getActiveWindowsHistoryForApp(appName, DateTime.fromJSDate(this.setZeroTimeForLocalDate(new Date())), this.userId, this.tenantId).subscribe(res => {
            this.HistoryDetails = res;
            this.LoadingStarted = false;
            this.HistoryForApp = "";
            if (this.HistoryDetails.length > 0) {
                this.ShowDetails = true;
                let element = document.getElementsByClassName('popTemplateClass');
                for (let i = 0; i < element.length; i++) {
                    element[i].className = element[i].className.replace(/\bdisplay-none\b/, "");
                }
            }
            else {
                this.ShowDetails = false;
                if (document?.getElementsByClassName('popTemplateClass')[0]?.className) {
                    document.getElementsByClassName('popTemplateClass')[0].className += ' display-none';
                }
            }
        });


    }
    setZeroTimeForLocalDate(date: Date): Date {
        date.setHours(0, 0, 0, 0);
        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    }

    removeData() {
        this.HistoryForApp = "";
        this.LoadingStarted = false;
        this.ShowDetails = false;
        this.HistoryDetails = [];

    }

}
